import update from "immutability-helper";

import {
  //Редактирование формы сообщения
  SET_MESSAGE_NAME,
  SET_MESSAGE_TEXT,
  SET_MESSAGE_TYPE,
  TOGGLE_MSG_CLIENTS_ROLE,
  TOGGLE_MSG_CONSULTANTS_ROLE,
  CLEAR_MESSAGE_FORM,
  //Загрузка информации о сообщении
  EDITING_MESSAGE_LOADING_START,
  EDITING_MESSAGE_LOADED_SUCCESSFULLY, 
  EDITING_MESSAGE_LOADING_FAILED,
  //Редактирование сообщения
  MESSAGE_EDITING_START,
  MESSAGE_EDITED_SUCCESSFULLY,
  MESSAGE_EDITING_FAILED,
  //Создание сообщения
  MESSAGE_CREATION_START,
  MESSAGE_CREATED_SUCCESSFULLY,
  MESSAGE_CREATION_FAILED,
} from "../actions/editMessage";

import { SIGN_OUT } from '../actions/auth';

const INITIAL_STATE = {
  ready: true,
  loading: false,
  message: {
    id: 0,
    title: '',
    message: '',
    type: 'release',
    clients: false,
    consultants: false,
  },
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    //Редактирование и создание сообщения
    case EDITING_MESSAGE_LOADED_SUCCESSFULLY:
      //Оюработка загруженного сообщения
      let loadedMessage = action.payload.message;
      //Роли сообщения
      const roles = action.payload.message.role;
      const isForClient = roles.findIndex( role => role === 'client' ) !== -1;
      const isForConsultant = roles.findIndex( role => role === 'consultant' ) !== -1;
      switch(true){
        case (isForClient && isForConsultant):
          loadedMessage.clients = true;
          loadedMessage.consultants = true;
          break;
        case (isForClient && !isForConsultant):
          loadedMessage.clients = true;
          loadedMessage.consultants = false;
          break;
        case (!isForClient && isForConsultant):
          loadedMessage.clients = false;
          loadedMessage.consultants = true;
          break;
        default:
          loadedMessage.clients = true;
          loadedMessage.consultants = true; 
          break;
      }

      return {
        ...state,
        ready: true,
        loading: false,
        message: loadedMessage,
      };
    case EDITING_MESSAGE_LOADING_FAILED:
    case MESSAGE_EDITING_FAILED:
    case MESSAGE_CREATION_FAILED:
      return {
        ...state,
        ready: false,
        loading: false,
      };
    //Редактирование сообщения
    case EDITING_MESSAGE_LOADING_START:
    case MESSAGE_EDITING_START:
    case MESSAGE_CREATION_START:
      return {
        ...state,
        ready: false, 
        loading: true,
      };
    case MESSAGE_EDITED_SUCCESSFULLY:
    case MESSAGE_CREATED_SUCCESSFULLY:
    case CLEAR_MESSAGE_FORM:
      return INITIAL_STATE;
    //Редактирование формы сообщения
    case SET_MESSAGE_NAME:
      return update(state, {
        message: {
          title: {$set: action.payload.value},
        }
      });
    case SET_MESSAGE_TEXT:
      return update(state, {
        message: {
          message: {$set: action.payload.value},
        }
      });
    case SET_MESSAGE_TYPE:
      return update(state, {
        message: {
          type: {$set: action.payload.value},
        }
      });
    case TOGGLE_MSG_CLIENTS_ROLE:
      return update(state, {
        message: {
          clients: {$set: !state.message.clients},
        }
      });
    case TOGGLE_MSG_CONSULTANTS_ROLE:
      return update(state, {
        message: {
          consultants: {$set: !state.message.consultants},
        }
      });
    case SIGN_OUT:
      return INITIAL_STATE;
    default:
      return state;
  }
}
